import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';

import { UiIconsModule } from 'ui-icons';

import { NavigationItem } from './models/vertical-navigation-sidebar.model';

@Component({
  selector: 'ui-platform-vertical-navigation-sidebar',
  templateUrl: './vertical-navigation-sidebar.component.html',
  styleUrl: './vertical-navigation-sidebar.component.less',
  imports: [
    NgIf,
    NgFor,
    NzAnchorModule,
    UiIconsModule,
    TranslocoPipe
  ]
})
export class VerticalNavigationSidebarComponent implements OnChanges {
  @Input() navigationItems: NavigationItem[] = [];
  @Input() offsetTop = 0;
  @Input() boundingArea = 5;

  isLeadingIconVisible = false;

  ngOnChanges(changes: SimpleChanges): void {
    this.isLeadingIconVisible = (changes.navigationItems.currentValue as NavigationItem[]).some(navigationItem => navigationItem.complete !== undefined);
  }
}
